// extracted by mini-css-extract-plugin
module.exports = {"mosaicContainer":"Mosaic_mosaicContainer__12Zbt","mosaicElement":"Mosaic_mosaicElement__2z520","elementImg":"Mosaic_elementImg__1oX2B","elementTitle":"Mosaic_elementTitle__3W9ks"};